import http from "../../http-common";
/* eslint-disable */
class BeritaService {
  beritaList(page, itemPerPage, keyword, kategori) {
    return http.get(
      "/berita/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&kategori_berita_id=" +
        kategori,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  getBerita(id) {
    return http.get("/berita?id=" + id, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data, content, photo) {
    var bodyFormData = new FormData();
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("kategori_berita_id", data.selectedKategori.id);

    if (content) bodyFormData.append("konten", content);

    if (data.link_youtube)
      bodyFormData.append("link_youtube", data.link_youtube);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("data_status", data.selectedHide.code);
    }

    if (photo != null) bodyFormData.append("photo", photo);

    return http.post("/berita", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data, content, photo) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("kategori_berita_id", data.selectedKategori.id);
    if (content) bodyFormData.append("konten", content);

    if (data.link_youtube)
      bodyFormData.append("link_youtube", data.link_youtube);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("data_status", data.selectedHide.id);
    }

    if (data.foto_url != null) bodyFormData.append("photo", photo);

    return http.put(`/berita/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/berita/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new BeritaService();
